import { useState, useEffect } from 'react'
import { LeaderboardEntry } from '../types'

const STORAGE_KEY = 'brawn_vs_brains_leaderboard'

export function useLeaderboard() {
  const [entries, setEntries] = useState<LeaderboardEntry[]>([])

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored) {
      try {
        setEntries(JSON.parse(stored))
      } catch (e) {
        console.error('Failed to parse leaderboard', e)
      }
    }
  }, [])

  const addEntry = (entry: Omit<LeaderboardEntry, 'id' | 'date'>): string => {
    const newEntry: LeaderboardEntry = {
      ...entry,
      id: crypto.randomUUID(),
      date: new Date().toISOString(),
    }
    const updated = [...entries, newEntry]
    setEntries(updated)
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated))
    return newEntry.id
  }

  const updateEntry = (
    id: string,
    patch: Partial<Omit<LeaderboardEntry, 'id'>>,
  ) => {
    const updated = entries.map((e) =>
      e.id === id ? { ...e, ...patch, date: new Date().toISOString() } : e,
    )
    setEntries(updated)
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated))
  }

  const deleteEntry = (id: string) => {
    const updated = entries.filter((e) => e.id !== id)
    setEntries(updated)
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated))
  }

  const getTopScores = (type: 'brawn' | 'brains', limit = 10) => {
    return entries
      .filter((e) => e.type === type)
      .sort((a, b) => b.score - a.score)
      .slice(0, limit)
  }

  return { entries, addEntry, updateEntry, deleteEntry, getTopScores }
}
